import React, { useState } from "react";
import Header from "../Header";
import { supabase } from "../../../supabase";
import { compressPdf } from "./CompressPdf";

function AddPublication() {
  const [book, setBook] = useState("");
  const [category, setCategory] = useState("");
  const [author, setAuthor] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const MAX_SIZE = 500 * 1024; // 500 KB

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!book || !category || !author) {
      alert("All fields are required");
      return;
    }

    setLoading(true);
    let insertedId = null;

    try {
      /* 1️⃣ Insert DB first (PDF optional) */
      const { data, error } = await supabase
        .from("publications")
        .insert([
          {
            book,
            category,
            author,
            url: null,
          },
        ])
        .select()
        .single();

      if (error) throw error;
      insertedId = data.id;

      /* 2️⃣ If PDF is selected, process it */
      if (pdfFile) {
        const compressedPdf = await compressPdf(pdfFile);

        if (compressedPdf.size > MAX_SIZE) {
          throw new Error(
            `PDF is ${(compressedPdf.size / 1024).toFixed(
              1
            )} KB. Must be below 500 KB`
          );
        }

        const fileName = `${insertedId}.pdf`;

        const { error: uploadError } = await supabase.storage
          .from("publications")
          .upload(fileName, compressedPdf);

        if (uploadError) throw uploadError;

        const { data: urlData } = supabase.storage
          .from("publications")
          .getPublicUrl(fileName);

        const { error: updateError } = await supabase
          .from("publications")
          .update({ url: urlData.publicUrl })
          .eq("id", insertedId);

        if (updateError) throw updateError;
      }

      alert("Publication added successfully!");

      setBook("");
      setCategory("");
      setAuthor("");
      setPdfFile(null);
    } catch (err) {
      console.error(err);

      /* Rollback only if DB insert already happened */
      if (insertedId) {
        await supabase.from("publications").delete().eq("id", insertedId);
      }

      alert(err.message || "Failed. Rolled back safely.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="main-content" id="mainContent">
      <Header heading="Publications" />

      <form className="mt-4" onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-lg-8">
            <label>
              Name of the Book<span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="form-control mb-2"
              placeholder="Book Name"
              value={book}
              onChange={(e) => setBook(e.target.value)}
            />
          </div>
          <div className="col-lg-4">
            <label>
              Category<span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-control mb-2"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="">--Select--</option>
              <option value="Poetry">Poetry</option>
              <option value="Story/Short-stories">Story/Short-stories</option>
              <option value="Novel">Novel</option>
              <option value="Drama">Drama</option>
              <option value="Folksong">Folksong</option>
              <option value="History">History</option>
              <option value="Translation">Translation</option>
              <option value="Kai alammo">Kai alammo</option>
              <option value="Translation">Translation</option>
              <option value="Speeches">Speeches</option>
              <option value="Legend">Legend</option>
              <option value="Grammar">Grammar</option>
              <option value="Dictionary">Dictionary</option>
              <option value="Proverb">Proverb</option>
              <option value="Idiom Phrases">Idiom Phrases</option>
              <option value="Rituals and Festivities">
                Rituals and Festivities
              </option>
              <option value="Literary Magazine">Literary Magazine</option>
              <option value="Souvenir">Souvenir</option>
              <option value="Others">Others</option>
            </select>
          </div>
          <div className="col-lg-5">
            <label>
              Author<span style={{ color: "red" }}>*</span>
            </label>
            <input
              placeholder="Author"
              className="form-control mb-2"
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
            />
          </div>
          <div className="col-lg-5">
            <label>Choose PDF</label>
            <input
              type="file"
              className="form-control mb-2"
              accept="application/pdf"
              onChange={(e) => setPdfFile(e.target.files[0])}
            />
          </div>
        </div>

        <button className="btn btn-primary mt-3" disabled={loading}>
          {loading ? "Processing..." : "Submit"}
        </button>
      </form>
    </main>
  );
}

export default AddPublication;
